export default __webpack_public_path__ + "dce355e93cbb4c9b4773069dce719b38.png";